import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["isTrellisCompatibleComponent"],
  _excluded2 = ["isTrellisCompatibleComponent"];
import { forwardRef } from 'react';
import BaseToolbar, { TrellisBaseToolbar } from './BaseToolbar';
import { EDGE_TOOLBAR_FONT_SIZE, EDGE_TOOLBAR_ICON_SIZE, EDGE_TOOLBAR_LINE_HEIGHT, EDGE_TOOLBAR_HEIGHT } from './constants';
import { withNonTrellisForwardRefRenderFunc, withTrellisForwardRefRenderFunc } from '../withTrellisCompatibleHoc';
import { jsx as _jsx } from "react/jsx-runtime";
const BaseHorizontalEdgeToolbarRender = (props, ref) => {
  if (props.isTrellisCompatibleComponent) {
    const otherProps = _objectWithoutPropertiesLoose(props, _excluded);
    return /*#__PURE__*/_jsx(TrellisBaseToolbar, Object.assign({
      iconUse: "edge",
      firstButtonRounding: 'top left',
      lastButtonRounding: 'top right'
    }, otherProps, {
      forwardedRef: ref
    }));
  }
  const otherProps = _objectWithoutPropertiesLoose(props, _excluded2);
  return /*#__PURE__*/_jsx(BaseToolbar, Object.assign({
    fontSize: EDGE_TOOLBAR_FONT_SIZE,
    iconSize: EDGE_TOOLBAR_ICON_SIZE,
    lineHeight: EDGE_TOOLBAR_LINE_HEIGHT,
    height: EDGE_TOOLBAR_HEIGHT,
    firstButtonRounding: 'top left',
    lastButtonRounding: 'top right'
  }, otherProps, {
    forwardedRef: ref
  }));
};
export const LegacyHorizontalEdgeToolbar = /*#__PURE__*/forwardRef(withNonTrellisForwardRefRenderFunc(BaseHorizontalEdgeToolbarRender));
LegacyHorizontalEdgeToolbar.displayName = 'LegacyHorizontalEdgeToolbar';
export const TrellisHorizontalEdgeToolbar = /*#__PURE__*/forwardRef(withTrellisForwardRefRenderFunc(BaseHorizontalEdgeToolbarRender));
TrellisHorizontalEdgeToolbar.displayName = 'TrellisHorizontalEdgeToolbar';
export default LegacyHorizontalEdgeToolbar;